import { render, staticRenderFns } from "./InspectionPointQrCode.vue?vue&type=template&id=683cd0b4&scoped=true&"
import script from "./InspectionPointQrCode.vue?vue&type=script&lang=js&"
export * from "./InspectionPointQrCode.vue?vue&type=script&lang=js&"
import style0 from "./InspectionPointQrCode.vue?vue&type=style&index=0&id=683cd0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683cd0b4",
  null
  
)

export default component.exports